import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import { actionsType } from 'config/constants';
import Drawer from "components/Drawers/Drawer";
import WriteReview from './WriteReview';
import { features } from "config";
import TagManagerService from 'services/TagManager'
import style from './style.scss';



let actions = [];

const DrawerReviews = () => {
    if(!features.productReviews) return ''
    
    const [productId, setProductId] = useState(false); 
    const [skuId, setSkuId] = useState('');

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.WRITER_REVIEWS_OPEN, _open));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const _open = (payload) => {
        setProductId(payload?.value?.productId);
        setSkuId(payload?.value?.itemId)
    }

    const _close = (isClose = false) => {

        if(isClose){
            PubSub.dispatch(actionsType.DRAWER.WRITER_REVIEWS_CLOSE)
        }else{
            PubSub.dispatch(actionsType.DRAWER.WRITER_REVIEWS_CLOSE)
            TagManagerService.interaction('Escribir comentario (volver)', skuId,  'PDP -Reviews');
        }
    }


    return (
        <Drawer customClass={'drawer-reviews'} actionOpen={actionsType.DRAWER.WRITER_REVIEWS_OPEN} actionClose={actionsType.DRAWER.WRITER_REVIEWS_CLOSE}>
            <WriteReview _close={_close} productId={productId} itemId={skuId}/>
        </Drawer>
    )
}

export default DrawerReviews;